import { Flex, Tag } from "@familyzone/component-library";
import React from "react";
import { Cohort } from "../../../types/Cohorts";
import Link from "../../Link";

interface UserCohortsProps {
  cohorts: Cohort[];
}

export const UserCohorts: React.FC<UserCohortsProps> = ({ cohorts }) => {
  const cohortMap = ({ id, name }: Cohort): JSX.Element => {
    return (
      <Link key={id} data-testid={`cohort-link-${id}`} to={`/config/device/userdb/cohorts/${id}`}>
        <Flex mr="sp4" mb="sp4">
          <Tag tagLabel={name} variant="brand" />
        </Flex>
      </Link>
    );
  };
  return (
    <Flex flexWrap="wrap" mb="sp24">
      {cohorts.map(cohortMap)}
    </Flex>
  );
};
